class StoreFaq extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.addEventListener('click', this.#handleClick, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * @param {Event} event
   */
  #handleClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('.store-faq__question');
    if (!trigger || !this.contains(trigger)) return;

    const item = trigger.closest('.store-faq__item');
    if (!item) return;

    const panel = item.querySelector('.store-faq__answer-panel');
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      if (panel instanceof HTMLElement) {
        window.setTimeout(() => {
          if (!item.classList.contains('is-open')) {
            panel.hidden = true;
          }
        }, 300);
      }

      return;
    }

    if (panel instanceof HTMLElement) {
      panel.hidden = false;
    }

    requestAnimationFrame(() => {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    });
  };
}

if (!customElements.get('store-faq')) {
  customElements.define('store-faq', StoreFaq);
}
